import { adminAPIService } from './index'

const route = 'products'

export default {
  getProductById(id) {
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'get',
    })
  },
  updateProductCategoriesBySlug(products) {
    const body = `json=${encodeURIComponent(JSON.stringify(products))}`
    return adminAPIService({
      url: `${route}/category`,
      method: 'post',
      data: body,
    })
  },
  updateProductCategoriesById(products) {
    const body = `json=${encodeURIComponent(JSON.stringify(products))}`
    return adminAPIService({
      url: `${route}/category`,
      method: 'post',
      data: body,
    })
  },
}
